import { useMemo } from 'react';

import { type AssetSearchFilters } from '@air/api/types';

import { usePrivateWorkspaceAgentPanelSession } from '~/components/v2/components/workspace/workspace-agent-panel/PrivateWorkspaceAgentPanelProvider';
import { usePrivateWorkspaceAgentPromptCardClipsSearch } from '~/components/v2/components/workspace/workspace-agent-panel/queries/usePrivateWorkspaceAgentPromptCardClipsSearch';
import { toWorkspaceAgentPromptCardThumbnails } from '~/components/v2/components/workspace/workspace-agent-panel/utils/toWorkspaceAgentPromptCardThumbnails';
import { useURLBoardIdSelector } from '~/hooks/useURLBoardIdSelector';

export const usePrivateWorkspaceAgentResizeForSocialPromptCard = () => {
  const { workspaceId } = usePrivateWorkspaceAgentPanelSession();
  const urlBoardId = useURLBoardIdSelector();
  const boardId = urlBoardId || undefined;

  const filters = useMemo(
    (): AssetSearchFilters => ({
      // Same “Images” filter as the type filter dropdown (`assetFileKind`).
      assetFileKind: { is: 'image' },
      ...(boardId ? { board: { is: boardId } } : {}),
    }),
    [boardId],
  );

  const { data, isLoading } = usePrivateWorkspaceAgentPromptCardClipsSearch({ filters, workspaceId });

  const clips = data?.data.clips;
  const thumbnails = useMemo(() => toWorkspaceAgentPromptCardThumbnails(clips ?? []), [clips]);

  return {
    isPending: isLoading,
    thumbnails,
  };
};
